export default __webpack_public_path__ + "static/media/Icons_Edit_Regular.de8f58f2.svg";